import { render, staticRenderFns } from "./DetailText.vue?vue&type=template&id=02070ea5&functional=true&"
import script from "./DetailText.vue?vue&type=script&lang=js&"
export * from "./DetailText.vue?vue&type=script&lang=js&"
import style0 from "./DetailText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports